import firebase from 'firebase/app';
import invariant from 'tiny-invariant';

import { getOrCreateModelDocument } from '../machines/firebaseUtils';

// class that wraps firebase functionality that handles
// functionality around the model document
// hopefully we will continue to move functionality here
// to keep it firebase encapsulated in one area
class BuildingModel {
  ref?: firebase.firestore.DocumentReference;

  jobId?: number;

  constructor(jobId: number) {
    this.jobId = jobId;
  }

  async getBuildingModelReference() {
    invariant(this.jobId, 'Missing jobId from BuildingModel');
    const querySnapshot = (await getOrCreateModelDocument(this.jobId)).docs[0];
    this.ref = querySnapshot.ref;
    return this.ref;
  }
}

export { BuildingModel };
